import React from 'react';
import { Box, Container } from '@mui/material';

const Section = ({
  id,
  children,
  background = 'transparent',
  maxWidth = 'lg',
  sx = {},
  disableGutters = false,
  ...rest
}) => {
  return (
    <Box
      component='section'
      id={id}
      sx={{
        position: 'relative',
        background,
        py: { xs: 10, md: 14 },
        ...sx,
      }}
      {...rest}
    >
      <Container maxWidth={maxWidth} disableGutters={disableGutters}>
        {children}
      </Container>
    </Box>
  );
};

export default Section;
